// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2r-1";
export var movingGradient = "_2r-4";
export var movingGradientBlock = "_2r-2";
export var skeleton = "_2r-0";
export var skeletonText = "_2r-3";